// extracted by mini-css-extract-plugin
export default {"modalBody":"app__ModalBody__modalBody","hasVerticalScrollbar":"app__ModalBody__hasVerticalScrollbar"};